<template>
  <button
    v-show="isVisible || showDisabledIfNotVisible"
    :class="buttonClass"
    :disabled="isDisabled"
    @click="handleClick"
    v-bind="$attrs">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
  import { computed, toRefs, defineProps, ref, defineEmits } from "vue";
  import { usePermissionsAccess } from "@/composables/usePermissionsAccess";
  import { Permissions, PermissionLevels } from "@/models/permissions";

  const props = defineProps({
    permissionIds: {
      type: Array as () => Permissions[],
      default: () => [],
    },
    permissionLevel: {
      type: Number as () => PermissionLevels,
      default: PermissionLevels.None,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showDisabledIfNotVisible: {
      // shows the button if not visible but button is disabled
      type: Boolean,
      default: false,
    },
    class: {
      type: [String, Object],
      default: "",
    },
  });

  const {
    permissionIds,
    permissionLevel,
    disabled,
    showDisabledIfNotVisible,
    class: buttonClass,
  } = toRefs(props);

  const emit = defineEmits(["click"]);

  const handleClick = (event) => {
    emit("click", event);
  };

  const permissionsAccess = usePermissionsAccess();

  const isVisible = computed(() => {
    const permissionIdsValue = permissionIds?.value || [];
    return (
      permissionIdsValue.length === 0 ||
      permissionsAccess.hasPermission(permissionIdsValue, permissionLevel.value)
    );
  });

  const isDisabled = computed(() => {
    return (
      disabled.value || (!isVisible.value && showDisabledIfNotVisible.value)
    );
  });
</script>

<style scoped>
  button:disabled {
    /* color: #999;
        background: #e9e9e9;
        border: 1px solid #ccc;
        cursor: not-allowed;
        opacity: 0.5; */
    background-color: #e0e0e0;
    color: #979797;
    cursor: not-allowed;
    border: 1px solid #d7d8dd;
  }
</style>
